import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["className", "ratio", "children"];
import { jsx as R } from "react/jsx-runtime";
import c from "react";
import { c as n } from "../clsx-OuTLNxxd.js";
const u = "ImageRatio-module_image__-CuwU",
  l = "ImageRatio-module_image-inner__-I67j",
  g = "ImageRatio-module_aspect-ratio-card__ZwJ4j",
  _ = "ImageRatio-module_aspect-ratio-card-panorama__pJ5pT",
  C = "ImageRatio-module_aspect-ratio-card-compact__WwkQO",
  I = "ImageRatio-module_aspect-ratio-card-condensed__RZcIq",
  f = "ImageRatio-module_aspect-ratio-auto__dL4u6",
  A = "ImageRatio-module_aspect-ratio-rectangular__qzD2X",
  P = "ImageRatio-module_aspect-ratio-vertical__7G2TM",
  h = "ImageRatio-module_aspect-ratio-custom__PSWWg",
  t = {
    image: u,
    imageInner: l,
    aspectRatioCard: g,
    aspectRatioCardPanorama: _,
    aspectRatioCardCompact: C,
    aspectRatioCardCondensed: I,
    aspectRatioAuto: f,
    aspectRatioRectangular: A,
    aspectRatioVertical: P,
    aspectRatioCustom: h
  },
  x = /* @__PURE__ */c.memo(function (_ref) {
    let {
        className: e,
        ratio: a,
        children: m
      } = _ref,
      s = _objectWithoutProperties(_ref, _excluded);
    const r = a == "auto" ? w(s.width, s.height) : void 0,
      d = n({
        [t.aspectRatioAuto]: a == "auto",
        [t.aspectRatioCard]: a == "card",
        [t.aspectRatioCardPanorama]: a == "card-panorama",
        [t.aspectRatioCardCompact]: a == "card-compact",
        [t.aspectRatioCardCondensed]: a == "card-condensed",
        [t.aspectRatioRectangular]: a == "rectangular",
        [t.aspectRatioVertical]: a == "vertical",
        [t.aspectRatioCustom]: a == "custom"
      }),
      p = c.Children.map(m, function (i) {
        if (c.isValidElement(i)) return c.cloneElement(i, {
          className: t.imageInner
        });
      });
    return /* @__PURE__ */R("div", {
      className: n(t.image, d, e),
      style: r,
      children: p
    });
  }),
  w = (o, e) => ({
    "--custom-image-aspect-ratio": v(o, e)
  }),
  v = (o, e) => "".concat(e / o * 100, "%");
export { x as ImageRatio, w as computeAspectRatioStyle };